import { OwnerLayout } from 'components/layouts/owner'
import { NextHead } from 'components/shared/NextHead'
import { NextPageWithHead } from 'pages/_app'

type Props = {
  owner?: Owner
}

const OwnerShow: NextPageWithHead<Props> = ({ owner: ownerFromServerSide }) => {
  return <OwnerLayout ownerFromServerSide={ownerFromServerSide} />
}

OwnerShow.getHead = ({ owner }: Props) => (
  <NextHead
    title={`${owner?.name}｜ArtX`}
    type="article"
    thumbnailUrl={owner?.cover_url}
    description={owner?.description}
  />
)

export { getServerSidePropsForOwnerDetailPage as getServerSideProps } from 'components/pages/owners/libs/getServerSidePropsForOwnerDetailPage'

export default OwnerShow
